import React from "react";
import classnames from 'classnames';
import AnimatedSprite from "../sprites/AnimatedSprite";
import HopAround from "../animations/HopAround";
import Wiggle from "../animations/Wiggle";
import Vortex from "../animations/Vortex";
import Bounce from "../animations/Bounce";
import Jump from "../animations/Jump";
import Fade from "../animations/Fade";
import assets from "./assets.json";
import * as s from "./Llama.module.css";

const Llama = ({
    type = "llama",
    className,
    animation,
    style,
    scale=3,
    onMouseUp,
    onMouseDown,
    onMouseMove,
    onClick,
    ...rest
}) => {
    const asset = assets.find((a) => a.name === type);
    if (!asset) {
        return null;
    }

    let Wrapper = "div";
    let wrapperProps = {};

    switch(animation) {
        case "vortex":
            Wrapper = Vortex;
            break;
        case "wiggle":
            Wrapper = Wiggle;
            wrapperProps = { strength: 0.2 };
            break;
        case "jump":
            Wrapper = Jump;
            wrapperProps = {delay: '3s'};
            break;
        case "walking":
            Wrapper = HopAround;
            wrapperProps = {to: {x:'300px'}, duration:'5s'};
            break;
        case "fade":
            Wrapper = Fade;
            wrapperProps = {delay: "3s"};
            break;
        case "bounce":
            Wrapper = Bounce;
            wrapperProps = {duration: '0.8s'};
            break;
    }

    return (
        <div
            className={classnames(s["root"], className)}
            style={style}
            onClick={onClick}
            onMouseUp={onMouseUp}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
        >
        <Wrapper {...wrapperProps}>
            <AnimatedSprite
                src={asset.src}
                frameDuration={300}
                bounds={asset.bounds}
                frame={asset.frame}
                scale={scale}
                pixelated
                {...rest}
            />
        </Wrapper>
        </div>
    );
};

export default Llama;
